<section *ngIf="authService.getUsuario">
  <app-mainavbar [idRol]="authService.getUsuario.fk_rol" [idNivel]="authService.getUsuario.fk_nivel"></app-mainavbar>
  <div *ngIf="authService.getUsuario.fk_nivel == 0 ">

    <div *ngIf="totalesGenerales" class="flex flex-wrap justify-content-evenly boxs">
      <p-card [header]="'Productos'" class="animate px-5 py-3" [style]="{textAlign: 'center'}"><a
          [routerLink]="['./productos']">{{totalesGenerales.productos}} </a> </p-card>
      <p-card [header]="'Médicos'" class="animate px-5 py-3" [style]="{textAlign: 'center'}"><a
          [routerLink]="['./medicos']"> {{totalesGenerales.medicos}} </a></p-card>
      <p-card [header]="'Enfermeras'" class="animate px-5 py-3" [style]="{textAlign: 'center'}"><a
          [routerLink]="['./enfermeras']">{{totalesGenerales.enfermeras}}</a> </p-card>
      <p-card [header]="'Supervisores'" class="animate px-5 py-3" [style]="{textAlign: 'center'}"><a
          [routerLink]="['./supervisores']"> {{totalesGenerales.supervisores}} </a></p-card>
      <p-card [header]="'Casos Clínicos'" class="animate px-5 py-3" [style]="{textAlign: 'center'}"> <a
          [routerLink]="['./casosclinicos']">{{totalesGenerales.casosclinicos}}</a> </p-card>
    </div>

  </div>
  <div *ngIf="authService.getUsuario.fk_nivel == 1">
    <div *ngIf="totalesGenerales" class="flex flex-wrap justify-content-evenly boxs">
      <p-card [header]="'Productos'" class="animate px-5 py-3" [style]="{textAlign: 'center'}">
        {{totalesGenerales.productos}} </p-card>
      <p-card [header]="'Médicos'" class="animate px-5 py-3" [style]="{textAlign: 'center'}">
        <a [routerLink]="['./medicos']"> {{totalesGenerales.medicos}} </a> </p-card>
      <p-card [header]="'Enfermeras'" class="animate px-5 py-3" [style]="{textAlign: 'center'}">
        <a [routerLink]="['./enfermeras']">{{totalesGenerales.enfermeras}}</a> </p-card>
      <p-card [header]="'Supervisores'" class="animate px-5 py-3" [style]="{textAlign: 'center'}">
        <a [routerLink]="['./supervisores']"> {{totalesGenerales.supervisores}} </a> </p-card>
      <p-card [header]="'Casos Clínicos'" class="animate px-5 py-3" [style]="{textAlign: 'center'}">
        <a [routerLink]="['./casosclinicos']">{{totalesGenerales.casosclinicos}}</a> </p-card>
    </div>
  </div>
  <div *ngIf="authService.getUsuario.fk_nivel == 2">
    <div *ngIf="totalesGenerales" class="flex flex-wrap justify-content-evenly boxs">
      <p-card [header]="'Productos'" class="animate px-5 py-3" [style]="{textAlign: 'center'}">
        <a [routerLink]="['./productos']">{{totalesGenerales.productos}} </a> </p-card>
      <p-card [header]="'Médicos'" class="animate px-5 py-3" [style]="{textAlign: 'center'}">
        {{totalesGenerales.medicos}} </p-card>
      <p-card [header]="'Enfermeras'" class="animate px-5 py-3" [style]="{textAlign: 'center'}">
        {{totalesGenerales.enfermeras}} </p-card>
      <p-card [header]="'Supervisores'" class="animate px-5 py-3" [style]="{textAlign: 'center'}">
        {{totalesGenerales.supervisores}} </p-card>
      <p-card [header]="'Casos Clínicos'" class="animate px-5 py-3" [style]="{textAlign: 'center'}">
        {{totalesGenerales.casosclinicos}} </p-card>
    </div>
  </div>

  <router-outlet></router-outlet>

</section>